"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_FINAL_STATUSES = exports.GIFT_CONTACT_SYNC_STATUSES = exports.GIFT_REQUEST_STATUSES = exports.giftStatuses = void 0;
var giftStatuses = {
  GIFT_CREATED: 10,
  NEED_MORE_INFO: 15,
  REVIEW: 18,
  PRODUCTS_PROPOSED: 20,
  SCHEDULED: 25,
  WAITING_GIFT_INVITATION: 27,
  GIFT_EMAIL_SENT: 30,
  GIFT_ACCESSED: 40,
  GIFT_CLAIMED: 50,
  NEED_FINISH_INFO: 60,
  FINALIZED: 70,
  EXPIRED: 80,
  DISABLED: 100
};
exports.giftStatuses = giftStatuses;
var GIFT_REQUEST_STATUSES = {
  IDLE: 'idle',
  LOADING: 'loading',
  COMPLETED: 'completed'
};
exports.GIFT_REQUEST_STATUSES = GIFT_REQUEST_STATUSES;
var GIFT_CONTACT_SYNC_STATUSES = {
  COMPLETED: 'completed',
  ERROR: 'error',
  IN_PROGRESS: 'in_progress',
  NEW: 'new',
  NOT_FOUND: 'not_found'
};
exports.GIFT_CONTACT_SYNC_STATUSES = GIFT_CONTACT_SYNC_STATUSES;
var VALID_FINAL_STATUSES = [GIFT_CONTACT_SYNC_STATUSES.COMPLETED, GIFT_CONTACT_SYNC_STATUSES.NOT_FOUND, GIFT_CONTACT_SYNC_STATUSES.ERROR];
exports.VALID_FINAL_STATUSES = VALID_FINAL_STATUSES;